import { Action } from '@ngrx/store';

export enum SecurityGuardActionTypes {
  INIT_GUARD_DETAILS = '[Cyclops Security Guard] Init Guard Module',
  GET_VISITOR_DETAILS = '[Cyclops Security Guard] Get Visitor Details',
  GET_VISITOR_DETAILS_SUCCESS = '[Cyclops Security Guard] Get Visitor Details Success',
  GET_VISITOR_DETAILS_FAILURE = '[Cyclops Security Guard] Get Visitor Details Failure',
  NOTIFY_VISITOR_HOST = '[Cyclops Security Guard] Notify Visitor Host',
  NOTIFY_VISITOR_HOST_SUCCESS = '[Cyclops Security Guard] Notify Visitor Host Success',
  NOTIFY_VISITOR_HOST_FAILURE = '[Cyclops Security Guard] Notify Visitor Host Failure',
  SAVE_AVAILABLE_VIDEO_DEVICES = '[Cyclops Security Guard] Save Available Video Devices',
  VISITOR_CHECKOUT = '[Cyclops Security Guard] Visitor Checkout',
  VISITOR_CHECKOUT_SUCCESS = '[Cyclops Security Guard] Visitor Checkout Success',
  VISITOR_CHECKOUT_FAILURE = '[Cyclops Security Guard] Visitor Checkout Failure',
  VISITOR_RE_CHECKIN = '[Cyclops Security Guard] Visitor Re-CheckIn',
  VISITOR_RE_CHECKIN_SUCCESS = '[Cyclops Security Guard] Visitor Re-CheckIn Success',
  VISITOR_RE_CHECKIN_FAILURE = '[Cyclops Security Guard] Visitor Re-CheckIn Failure',
  VISITOR_RE_CHECKOUT = '[Cyclops Security Guard] Visitor Re-Checkout',
  VISITOR_RE_CHECKOUT_SUCCESS = '[Cyclops Security Guard] Visitor Re-Checkout Success',
  VISITOR_RE_CHECKOUT_FAILURE = '[Cyclops Security Guard] Visitor Re-Checkout Failure',

  CHECK_VISITOR_VEHICLE = '[Cyclops Security Guard] Check Visitor Vehicle',
  CHECK_VISITOR_VEHICLE_SUCCESS = '[Cyclops Security Guard] Check Visitor Vehicle Success',
  CHECK_VISITOR_VEHICLE_FAILURE = '[Cyclops Security Guard] Check Visitor Vehicle Failure',
  GET_SCANNED_QR_VISITOR_DETAILS = '[Cyclops Security Guard] Get Scanned Qr Visitor Details',
  RESET_STATE = '[Cyclops Security Guard] Reset State',
}
export class ResetState implements Action {
  readonly type = SecurityGuardActionTypes.RESET_STATE;
  constructor(public payload: any) {}
}
export class InitGuardDetails implements Action {
  readonly type = SecurityGuardActionTypes.INIT_GUARD_DETAILS;
  constructor(public payload: any) {}
}
export class GetVisitorDetails implements Action {
  readonly type = SecurityGuardActionTypes.GET_VISITOR_DETAILS;
  constructor(public payload: any) {}
}
export class GetVisitorDetailsSuccess implements Action {
  readonly type = SecurityGuardActionTypes.GET_VISITOR_DETAILS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetVisitorDetailsFailure implements Action {
  readonly type = SecurityGuardActionTypes.GET_VISITOR_DETAILS_FAILURE;
  constructor(public payload: any) {}
}
export class NotifyVisitorHost implements Action {
  readonly type = SecurityGuardActionTypes.NOTIFY_VISITOR_HOST;
  constructor(public payload: any) {}
}
export class NotifyVisitorHostSuccess implements Action {
  readonly type = SecurityGuardActionTypes.NOTIFY_VISITOR_HOST_SUCCESS;
  constructor(public payload: any) {}
}
export class NotifyVisitorHostFailure implements Action {
  readonly type = SecurityGuardActionTypes.NOTIFY_VISITOR_HOST_FAILURE;
  constructor(public payload: any) {}
}
export class SaveAvailableVideoDevices implements Action {
  readonly type = SecurityGuardActionTypes.SAVE_AVAILABLE_VIDEO_DEVICES;
  constructor(public payload: any) {}
}
export class GetScannedQrVisitorDetails implements Action {
  readonly type = SecurityGuardActionTypes.GET_SCANNED_QR_VISITOR_DETAILS;
  constructor(public payload: any) {}
}
export class VisitorCheckOut implements Action {
  readonly type = SecurityGuardActionTypes.VISITOR_CHECKOUT;
  constructor(public payload: any) {}
}
export class VisitorCheckOutSuccess implements Action {
  readonly type = SecurityGuardActionTypes.VISITOR_CHECKOUT_SUCCESS;
  constructor(public payload: any) {}
}
export class VisitorCheckOutFailure implements Action {
  readonly type = SecurityGuardActionTypes.VISITOR_CHECKOUT_FAILURE;
  constructor(public payload: any) {}
}
export class VisitorReCheckIn implements Action {
  readonly type = SecurityGuardActionTypes.VISITOR_RE_CHECKIN;
  constructor(public payload: any) {}
}
export class VisitorReCheckInSuccess implements Action {
  readonly type = SecurityGuardActionTypes.VISITOR_RE_CHECKIN_SUCCESS;
  constructor(public payload: any) {}
}
export class VisitorReCheckInFailure implements Action {
  readonly type = SecurityGuardActionTypes.VISITOR_RE_CHECKIN_FAILURE;
  constructor(public payload: any) {}
}
export class CheckVisitorVehicle implements Action {
  readonly type = SecurityGuardActionTypes.CHECK_VISITOR_VEHICLE;
  constructor(public payload: any) {}
}
export class CheckVisitorVehicleSuccess implements Action {
  readonly type = SecurityGuardActionTypes.CHECK_VISITOR_VEHICLE_SUCCESS;
  constructor(public payload: any) {}
}
export class CheckVisitorVehicleFailure implements Action {
  readonly type = SecurityGuardActionTypes.CHECK_VISITOR_VEHICLE_FAILURE;
  constructor(public payload: any) {}
}
export class VisitorReCheckOut implements Action {
  readonly type = SecurityGuardActionTypes.VISITOR_RE_CHECKOUT;
  constructor(public payload: any) {}
}
export class VisitorReCheckOutSuccess implements Action {
  readonly type = SecurityGuardActionTypes.VISITOR_RE_CHECKOUT_SUCCESS;
  constructor(public payload: any) {}
}
export class VisitorReCheckOutFailure implements Action {
  readonly type = SecurityGuardActionTypes.VISITOR_RE_CHECKOUT_FAILURE;
  constructor(public payload: any) {}
}
export type CyclopsSecurityGuardActionUnion =
  | ResetState
  | InitGuardDetails
  | GetVisitorDetails
  | GetVisitorDetailsSuccess
  | GetVisitorDetailsFailure
  | NotifyVisitorHost
  | NotifyVisitorHostSuccess
  | NotifyVisitorHostFailure
  | SaveAvailableVideoDevices
  | VisitorCheckOut
  | VisitorCheckOutSuccess
  | VisitorCheckOutFailure
  | VisitorReCheckIn
  | VisitorReCheckInSuccess
  | VisitorReCheckInFailure
  | CheckVisitorVehicle
  | CheckVisitorVehicleSuccess
  | CheckVisitorVehicleFailure
  | VisitorReCheckOut
  | VisitorReCheckOutSuccess
  | VisitorReCheckOutFailure
  | GetScannedQrVisitorDetails;
